document.addEventListener("DOMContentLoaded", function () {
  function openTab(tab) {
    if (!tab.hasClass("active")) {
      tab.parent().next().slideDown() // Открываем текущий таб
      tab.addClass("active") // Делаем текущий таб активным
    } else {
      tab.removeClass("active")
      tab.parent().next().stop().slideUp() // Закрываем текущий таб
    }
  }

  $(".faq-question").on("click", function () {
    console.log($(this))
    openTab($(this))
  })

  const scrollLinks = $(".links-slider__link")

  scrollLinks.on("click", function (e) {
    e.preventDefault()

    // Убираем класс 'active' у всех ссылок
    scrollLinks.removeClass("active")

    // Добавляем класс 'active' к текущей ссылке
    $(this).addClass("active")

    // Получаем целевой элемент
    const targetId = $(this).attr("href")
    const targetElement = $(targetId)

    if (targetElement.length) {
      openTab(targetElement)

      const offsetTop = targetElement.offset().top - 280

      $("html, body").animate(
        {
          scrollTop: offsetTop,
        },
        800
      ) // 800 миллисекунд для плавного скроллирования
    }
  })
})
document.addEventListener("DOMContentLoaded", () => {
  const profileTabs = document.querySelectorAll(".profile-tabs-nav a")
  function myTabClicks(tabClickEvent) {
    for (var i = 0; i < profileTabs.length; i++) {
      profileTabs[i].classList.remove("active")
    }
    var clickedTab = tabClickEvent.currentTarget
    clickedTab.classList.add("active")
    tabClickEvent.preventDefault()

    window.history.pushState("", "", clickedTab.getAttribute("href"))
    var myContentPanes = document.querySelectorAll(".profile-tab-item")
    for (i = 0; i < myContentPanes.length; i++) {
      myContentPanes[i].classList.remove("active")
    }
    var anchorReference = tabClickEvent.target
    var activePaneId = anchorReference.getAttribute("href")
    var activePane = document.querySelector(activePaneId)
    activePane.classList.add("active")
  }
  for (i = 0; i < profileTabs.length; i++) {
    profileTabs[i].addEventListener("click", myTabClicks)
  }
  document.querySelectorAll(".section-recipe-block__more").forEach((button) => {
    button.addEventListener("click", function () {
      const textBlock = this.previousElementSibling
      const isVisible = textBlock.classList.contains("more-visible")

      // Remove the class to measure the content's full height
      textBlock.classList.remove("more-visible")
      const fullHeight = textBlock.scrollHeight + "px"

      // Apply height transition
      if (isVisible) {
        textBlock.style.height = fullHeight
        requestAnimationFrame(() => {
          textBlock.style.height = "0"
        })
      } else {
        textBlock.style.height = fullHeight
        requestAnimationFrame(() => {
          textBlock.style.height = fullHeight
          textBlock.classList.add("more-visible")
        })
      }

      // Toggle the text content of the button
      this.textContent = isVisible ? "+ More Dimensions" : "- Fewer Dimensions"
    })
  })
  document.querySelectorAll(".section-recipe-block__more2").forEach((button) => {
    button.addEventListener("click", function () {
      const textBlock = this.previousElementSibling.previousElementSibling
      const isVisible = textBlock.classList.contains("more-visible")

      // Remove the class to measure the content's full height
      textBlock.classList.remove("more-visible")
      const fullHeight = textBlock.scrollHeight + "px"

      // Apply height transition
      if (isVisible) {
        textBlock.style.height = fullHeight
        requestAnimationFrame(() => {
          textBlock.style.height = "0"
        })
      } else {
        textBlock.style.height = fullHeight
        requestAnimationFrame(() => {
          textBlock.style.height = fullHeight
          textBlock.classList.add("more-visible")
        })
      }

      // Toggle the text content of the button
      this.textContent = isVisible ? "See Dimensions" : "Close Dimensions"
    })
  })
})
document.addEventListener("DOMContentLoaded", () => {
  const sliderReviews = new Swiper(".section-reviews-slider", {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 1,
    speed: 500,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-arrow--next",
      prevEl: ".swiper-arrow--prev",
    },
  })
})
